export const initMegaDropdownGrow = () => {
   const dropdownParents = document.querySelectorAll('.main-nav__item.has-children');

   if (!dropdownParents.length) {
      return;
   }
   else {
      dropdownParents.forEach((parent) => {
         const dropdown = parent.querySelector('.child-nav-wrapper');

         parent.addEventListener('mouseenter', () => {
            dropdown.style.height = dropdown.scrollHeight + 'px';
         });

         parent.addEventListener('mouseleave', () => {
            dropdown.style.height = dropdown.scrollHeight + 'px';
            requestAnimationFrame(() => {
               dropdown.style.height = '0px';
            });
         });
      });
   }
};